<template>
    <div class="info">
        <div class="table-wrap">
            <div class="headtable-top">
                <p><span class="c-red">*</span> 표시는 필수 입력 항목입니다.</p>
            </div>
            <div class="table headtable">
                <table>
                    <colgroup>
                        <col style="width:25%;">
                        <col style="width:25%;">
                        <col style="width:25%;">
                        <col style="width:25%;">
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>
                                <h4 class="title03"><span class="c-red">*</span> 작성일</h4>
                            </th>
                            <td>
                                <VueDatePicker v-model="params.logDt" locale="ko" :format="formatDate"
                                    :enable-time-picker="false" week-start="0" position="left" placeholder="날짜를 선택하세요."
                                    auto-apply />
                            </td>
                            <th>
                                <h4 class="title03"><span class="c-red">*</span> 체중</h4>
                            </th>
                            <td>
                                <div class="baby-weight">
                                    <input type="text" class="head-symptom__input" v-model="params.weight" @input="this.$commonUtils.numberPeriodOnly" maxlength="10">
                                    <p>kg</p>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <h4 class="title03">사진등록</h4>
                            </th>
                            <td colspan="3" class="left">
                                <ul class="mother-diary__photo-list">
                                    <li class="mother-diary__photo-item" v-if="imgCount < 10">
                                        <a href="javascript:;" class="mother-diary__photo-plus" @click="selectFile">
                                            <img src="/resource/icon/plus.svg" alt="">
                                            사진등록<br>
                                            ({{imgCount}}/10)
                                        </a>
                                    </li>
                                    <li class="mother-diary__photo-item" v-for="i in 10" :key="i" style="display: none;" :name="`wrap${i}`">
                                        <input type="file" :name="`file${i}`" class="file" accept="image/*" @change="changeFile" hidden>
                                        <a href="javascript:;" class="mother-diary__photo-close" style="" @click.stop="deleteFile(i)"></a>
                                        <img src="" alt="" :name="`img${i}`">
                                    </li>
                                </ul>
                                <p><span class="c-red">*</span> 첫 번째로 등록하신 이미지가 대표 이미지 입니다.</p>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <h4 class="title03">메모</h4>
                            </th>
                            <td colspan="3" class="left">
                                <textarea name="" id="" placeholder="자유롭게 작성해주세요." v-model="params.memo" maxlength="500"></textarea>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <h4 class="title03">
                                    <span class="c-red">*</span> 기분
                                </h4>
                                <sub>(다중 선택 가능)</sub>
                            </th>
                            <td colspan="3">
                                <ul class="head-symptom__list">
                                    <li v-for="(item, idx) in mood" :key="item">
                                        <a href="javascript:;" :class="{'active': params.mood.includes(item)}" @click="toggleMood(item)">
                                            <div :class="`icon mother-mood${('0' + (idx + 1)).slice(-2)}`"></div>
                                            <p>{{item}}</p>
                                        </a>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <h4 class="title03">
                                    <span class="c-red">*</span> 건강 상태
                                </h4>
                                <sub>(다중 선택 가능)</sub>
                            </th>
                            <td colspan="3">
                                <ul class="head-symptom__list">
                                    <li v-for="(item, idx) in fig" :key="item">
                                        <a href="javascript:;" :class="{'active': params.fig.includes(item)}" @click="toggleFig(item)">
                                            <div :class="`icon mother-state${('0' + (idx + 1)).slice(-2)}`"></div>
                                            <p>{{item}}</p>
                                        </a>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="botton-wrap nowrap">
            <a href="javascript:;" class="sub-button c-gray" @click="cancelDiary">취소</a>
            <a href="javascript:;" class="main-button c-main" @click="saveSubmit">{{bdSn ? '수정' : '등록'}}</a>
        </div>
    </div>

    <kr_popup_health ref="MypagePopupVue"/>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
    components: {
        VueDatePicker,
    },
    data() {
        return {
            formatDate: 'yyyy-MM-dd', // 원하는 날짜 형식 설정

            mood: [
                '즐거움','행복','기쁨','설렘','그럭저럭','짜증','뾰로통','지침','불안','괴로움'
            ],
            fig: [
                '입덧','구역질','어지러움','빈혈','갈색출혈','출혈','태동','당김','변비','부종','요통','몸상태 좋지않음','두통','복통','졸음','나른함','불면증','피부 트러블','다리경련','관절통','가슴통증','두근거림','배변','약물복용'
            ],

            params: {
                logDt: this.$store.state.reserveStore.diaryDate || null, // 초기값 설정
                fig: [],
                mood: [],
            },

            imgCount: 0,

            bdSn: this.$route.query.bdSn || '',
            len: 0,
        };
    },
    methods: {
        deleteFile(idx){
            const src = document.querySelector('img[name=img'+idx+']').getAttribute('src')
            document.querySelector('input[name=file'+idx+']').value = ''
            document.querySelector('img[name=img'+idx+']').setAttribute('src', '')
            document.querySelector('li[name=wrap'+idx+']').style.display = 'none'
            this.imgCount--
            if(this.params.attachBag && src.indexOf('attachNo') > -1){
                const list = JSON.parse(this.params.attachBag)
                for(let i of list){
                    if(i.attachNo == src.split('attachNo=')[1]){
                        i.refMapCode = '_delete'
                    }
                }
                this.params.attachBag = JSON.stringify(list)
            }
        },
        selectFile(){
            for(let i = 1; i <= 10; i++) {
                // const file = document.querySelector('input[name=file'+i+']').files[0]
                const src = document.querySelector('img[name=img'+i+']').getAttribute('src')
                if(!src){
                    document.querySelector('input[name=file'+i+']').click()
                    break
                }
            }
        },
        changeFile(event){
            const file = event.target.files[0]
            const name = event.target.name
            if(name && file){
                const index = name.replace('file','')
                const img = document.querySelector('img[name=img' + index + ']')
                const wrap = document.querySelector('li[name=wrap' + index + ']')
                const reader = new FileReader()
                reader.onload = (e) => {
                    const imgUrl = e.target.result
                    img.setAttribute('src', imgUrl)
                    img.style.display = 'block'
                    wrap.style.display = 'block'
                }
                reader.readAsDataURL(file)
                this.imgCount++
            }
        },
        toggleMood(mood){
            const index = this.params.mood.indexOf(mood);
            if (index === -1) {
                this.params.mood.push(mood);
            } else {
                this.params.mood.splice(index, 1);
            }
        },
        toggleFig(fig){
            const index = this.params.fig.indexOf(fig);
            if (index === -1) {
                this.params.fig.push(fig);
            } else {
                this.params.fig.splice(index, 1);
            }
        },
        saveSubmit() {
            if(!this.params.logDt){
                alert('작성일을 입력해주세요.')
                return
            }
            if(!this.params.weight){
                alert('체중을 입력해주세요.')
                return
            }
            if(this.params.mood.length == 0){
                alert('기분을 선택해주세요.')
                return
            }
            if(this.params.fig.length == 0){
                alert('건강 상태를 선택택해주세요.')
                return
            }
            
            this.$refs.MypagePopupVue.popupBtn()
        },
        submit(){
            if(!this.params.logDt){
                alert('작성일을 입력해주세요.')
                return
            }
            if(!this.params.weight){
                alert('체중을 입력해주세요.')
                return
            }
            if(this.params.mood.length == 0){
                alert('기분을 선택해주세요.')
                return
            }
            if(this.params.fig.length == 0){
                alert('건강 상태를 선택택해주세요.')
                return
            }

            const year = this.params.logDt.getFullYear()
            const month = ('0' + (this.params.logDt.getMonth() + 1)).slice(-2)
            const day = ('0' + this.params.logDt.getDate()).slice(-2)

            const data = new FormData();
            data.append('logDt', year + '' + month + '' + day + '000000');
            data.append('weight', this.params.weight);
            data.append('mood', this.params.mood.join(','));
            data.append('fig', this.params.fig.join(','));
            data.append('memo', this.params.memo ? this.params.memo : '');

            let list = []
            if(this.params.attachBag){
                list = JSON.parse(this.params.attachBag);
            }

            for(let i = 1; i <= 10; i++) {
                const file = document.querySelector('input[name=file'+i+']').files[0]
                if(file){
                    const obj = {};
                    obj.hospId = null;
                    obj.refKey = null;
                    obj.refType = 'babyDiary';
                    obj.refMapCode = 'attach';
                    obj.attachNo = null;
                    obj.savedName = null;
                    obj.savedDir = null;
                    obj.fileType = null;
                    obj.altValue = '';
                    obj.displayName = file.name;
                    obj.fileSize = String(file.size);

                    data.append('uploader', file);
                    list.push(obj)
                }
            }
            data.append('attachBag', JSON.stringify(list));

            let url = this.api.mypage.diaryReg

            if(this.bdSn){
                url = this.api.mypage.diaryUpdate
                data.append('bdSn', this.bdSn);
            }

            this.axios({
                method: "post",
                url: url,
                headers: { 'Content-type': 'multipart/form-data' },
                data: data
            })
            .then(res => {
                alert('저장되었습니다.')
                this.$router.push('/kr/mypage/babyNote/babyDiary')
            })
        },
        cancelDiary(){
            if(confirm('화면 이동시 작성 중인 내용은 사라집니다. 이동하시겠습니까까?')){
                this.$router.push('/kr/mypage/babyNote/babyDiary')
            }
        },
        getDetail(){
            this.axios.get(this.api.mypage.diaryDetail, {
                params: { bdSn: this.bdSn }
            })
            .then(res => {
                if(!res.data){
                    alert('이미 삭제된 데이터입니다.')
                    this.$router.go(-1)
                    return
                }
                const data = res.data
                const date = new Date(data.logDt)
                // const year = date.getFullYear()
                // const month = ('0' + (date.getMonth() + 1)).slice(-2)
                // const day = ('0' + date.getDate()).slice(-2)
                // this.params.logDt = `${year}-${month}-${day}`
                this.params.logDt = date
                this.params.weight = data.weight
                this.params.memo = data.memo
                this.params.mood = data.mood.split(',')
                this.params.fig = data.fig.split(',')
                if(data.attachBag.attach){
                    const attach = data.attachBag.attach
                    this.len = attach.length
                    this.imgCount = this.len

                    let list = []
                    for(let i = 0; i <= this.len - 1; i++){
                        const obj = {};
                        obj.hospId = attach[i].hospId;
                        obj.refKey = attach[i].refKey;
                        obj.refType = attach[i].refType;
                        obj.refMapCode = attach[i].refMapCode;
                        obj.attachNo = attach[i].attachNo;
                        obj.savedName = attach[i].savedName;
                        obj.savedDir = null;
                        obj.fileType = attach[i].fileType;
                        obj.altValue = attach[i].altValue;
                        obj.displayName = attach[i].name;
                        obj.fileSize = String(attach[i].fileSize);

                        list.push(obj)

                        document.querySelector('img[name=img'+(i + 1)+']').setAttribute('src', `/displayFile.do?attachNo=${attach[i].attachNo}`)
                        document.querySelector('li[name=wrap'+(i + 1)+']').style.display = 'block'
                    }
                    this.params.attachBag = JSON.stringify(list);
                }
            })
        }
    },
    mounted() {
        if(this.bdSn){
            this.getDetail()
        }
    },
};
</script>
<style scoped></style>